<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ "globals.save" | translate }}
  </h4>
</div>
<ng-container>
  <div class="modal-body">
    <ng-container>
      <div class="modal-body__title">
        <h6>{{ "developments.modal.update.question" | translate }}</h6>
      </div>
      <div class="modal-body__box">
        <form>
          <div class="modal-body__box__radio-container">
            <mat-radio-group [formControl]="developmentActionFormControl">
              <mat-radio-button [value]="1">{{
                "developments.modal.update.saveAction" | translate
              }}</mat-radio-button>
              <mat-radio-button [value]="2"
                >{{ "developments.modal.update.archiveAction" | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </form>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn cancelar" (click)="onDismiss()">
      {{ "globals.buttons.cancelar" | translate }}
    </button>
    <button type="button" class="btn acceptButton" (click)="onSend()">
      {{ "globals.buttons.accept" | translate }}
    </button>
  </div>
</ng-container>
